export default "__VITE_ASSET__DQ6kvOuU__"